import React, { useState } from 'react';
import { MapPin, ChevronDown, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCity } from '@/context/CityContext';
import CitySearchSheet from './CitySearchSheet';

export default function TopBar({ title, subtitle }) {
  const { city } = useCity();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <div className="sticky top-0 z-30 bg-[#FBFAF2]/85 backdrop-blur-xl border-b border-[#0F1A13]/06">
      <div className="px-4 pt-4 pb-3 flex items-center gap-3">
        <button
          type="button"
          aria-label="Go home"
          onClick={() => navigate('/')}
          className="shrink-0 gt-focus rounded-2xl flex items-center gap-2 px-2.5 py-1.5 hover:bg-[#0F1A13]/05 transition-colors tap-bounce"
          data-testid="topbar-logo"
        >
          <span className="w-8 h-8 rounded-xl overflow-hidden shadow-[0_4px_14px_rgba(15,26,19,0.18)]" data-testid="topbar-logo-icon">
            <img src="/brand/trivly-app-icon.png" alt="Trivly" className="w-full h-full object-cover" draggable={false} />
          </span>
          <span className="font-display font-bold text-[#0F1A13] text-[15px] tracking-tight">Trivly</span>
        </button>
        <button
          type="button"
          className="flex-1 max-w-[230px] gt-focus inline-flex items-center justify-center gap-1.5 rounded-full bg-[#0F1A13]/04 border border-[#0F1A13]/08 px-3.5 py-2 text-[12.5px] font-semibold text-[#0F1A13] hover:bg-[#0F1A13]/08 transition-colors ml-auto"
          onClick={() => setOpen(true)}
          data-testid="topbar-city-pill"
          aria-label="Change city"
        >
          <MapPin className="w-3.5 h-3.5 text-[#15291C]" />
          <span className="truncate">{city.name}{city.country ? `, ${city.country}` : ''}</span>
          <ChevronDown className="w-3.5 h-3.5 text-[#7A8A80]" />
        </button>
        <button
          type="button"
          aria-label="Search city"
          onClick={() => setOpen(true)}
          className="w-9 h-9 rounded-full bg-[#0F1A13]/04 border border-[#0F1A13]/08 flex items-center justify-center hover:bg-[#0F1A13]/08 transition-colors gt-focus"
          data-testid="topbar-search"
        >
          <Search className="w-4 h-4 text-[#15291C]" />
        </button>
      </div>
      {(title || subtitle) && (
        <div className="px-4 pb-3">
          {title && <h1 className="font-display text-2xl font-bold tracking-tight text-[#0F1A13]" data-testid="screen-title">{title}</h1>}
          {subtitle && <p className="text-sm text-[#4A5A50] mt-1">{subtitle}</p>}
        </div>
      )}
      <CitySearchSheet open={open} onOpenChange={setOpen} />
    </div>
  );
}
